import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import Footer from '../components/Footer';
import { useCart } from '../context/CartContext';
import { purchaseAttempt } from '../services/api';
import { usePageTracking } from '../hooks/usePageTracking';
import candyImage from '../assets/SambasCandy.png';
import './CandyPage.css';

// Pricing data object
const CANDY_PRICING = {
  60: {
    single: 2.79,
    3: 7.79,
    6: 14.49,
    12: 26.49,
    24: 49.99,
  },
  30: {
    single: 1.69,
    3: 4.79,
    6: 8.99,
    12: 16.49,
    24: 29.99,
  },
};

const PACK_OPTIONS = [
  { key: 'single', label: 'Single Pack', packs: 1 },
  { key: '3', label: '3 Pack', packs: 3 },
  { key: '6', label: '6 Pack', packs: 6 },
  { key: '12', label: '12 Pack', packs: 12 },
  { key: '24', label: '24 Pack', packs: 24 },
];

function Candy() {
  usePageTracking('candy');
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [selectedSize, setSelectedSize] = useState(60);
  const [selectedPack, setSelectedPack] = useState(null);

  const handleAddToCart = async (packKey) => {
    const packData = PACK_OPTIONS.find(p => p.key === packKey);
    const price = CANDY_PRICING[selectedSize][packKey];
    
    // Track the purchase attempt
    try {
      await purchaseAttempt.track('candy', `${selectedSize}g`, packKey, price);
      console.log(`✓ Purchase attempt tracked: ${selectedSize}g ${packKey} pack at $${price}`);
    } catch (err) {
      console.error('Failed to track purchase attempt:', err);
    }
    
    // Add to cart
    const cartItem = {
      id: `candy-${selectedSize}g-${packKey}`,
      product: 'Performance Candies',
      size: `${selectedSize}g`,
      packKey: packKey,
      packLabel: packData.label,
      price: price,
    };

    addToCart(cartItem);
    setSelectedPack(null);
  };

  return (
    <div className="candy-page">
      <BrandLogo />
      <div className="candy-container">
        {/* Free Shipping Banner */}
        <div className="free-shipping-banner">
          <span>Free shipping on orders over $50!</span>
        </div>

        {/* Back button - not fixed */}
        <button className="back-button-simple" onClick={() => navigate('/')}>
          <span className="back-text">← Back</span>
          <span className="back-arrow">←</span>
        </button>

        <div className="candy-content">
          {/* Product image box */}
          <div className="product-image-box">
            <img src={candyImage} alt="Sambas Performance Candies" className="product-image" />
          </div>

          {/* Product description */}
          <div className="product-description">
            <h2 className="product-title">Sambas Energy Performance Candies</h2>
            <p className="product-tagline">A fruity chewable candy infused with natural guarana caffeine for a smooth, lasting boost—no drinks, no crash, just pop and go.</p>
          </div>

          {/* Size selector inline */}
          <div className="size-selector-inline">
            {[60, 30].map((size) => (
              <button
                key={size}
                className={`size-btn ${selectedSize === size ? 'active' : ''}`}
                onClick={() => {
                  setSelectedSize(size);
                  setSelectedPack(null);
                }}
              >
                {size}G
              </button>
            ))}
          </div>

          {/* Pack options as vertical list */}
          <div className="pack-list">
            {PACK_OPTIONS.map((packOption) => {
              const price = CANDY_PRICING[selectedSize][packOption.key];
              const perPackPrice = packOption.packs > 1 ? (price / packOption.packs).toFixed(2) : null;
              const isSelected = selectedPack === packOption.key;

              const isBestDeal = packOption.key === '24';

              return (
                <div
                  key={packOption.key}
                  className={`pack-row ${isSelected ? 'selected' : ''} ${isBestDeal ? 'best-deal-row' : ''}`}
                  onClick={() => setSelectedPack(packOption.key)}
                >
                  {isBestDeal && <span className="best-deal-badge">BEST DEAL</span>}
                  <div className="pack-info">
                    <span className="pack-name">{packOption.label}</span>
                    <span className="pack-price">${price.toFixed(2)}</span>
                    {perPackPrice && (
                      <span className="per-pack-price">(${perPackPrice}/pack)</span>
                    )}
                  </div>

                  {isSelected && (
                    <button
                      className="add-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddToCart(packOption.key);
                      }}
                    >
                      Add to Cart
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Candy;
